import React from "react";
import { MaterialUiSelect } from "../Select";

interface ConditionDropdownProps {
  rowIndex: number;
  values: any;
  handleBlur: (e: any) => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  otherQueryFilterErrors: any;
  otherQueryFilterTouched: any;
  reportSummary: any;
}

const getDropdown = (type: string, repeat: boolean) => {
  switch (type) {
    case "id":
      return [
        { name: "Equal To ==", value: "==" },
        { name: "Not Equal To !=", value: "!=" },
        { name: "Less Than or Equal To <=", value: "<=" },
        { name: "Less Than <", value: "<" },
        { name: "Greater Than or Equal To >=", value: ">=" },
        { name: "Greater Than >", value: ">" },
      ];
    case "string":
    case "text":
      return [
        { name: "Equal To ==", value: "==" },
        { name: "Not Equal To !=", value: "!=" },
      ];
    case "boolean":
    case "gpsCoordinates":
    case "matrixdynamic":
      return [
        { name: "Equal To ==", value: "==" },
        { name: "Not Equal To !=", value: "!=" },
      ];
    case "integer":
    case "float":
    case "number":
    case "range":
      return [
        { name: "Equal To ==", value: "==" },
        { name: "Not Equal To !=", value: "!=" },
        { name: "Less Than or Equal To <=", value: "<=" },
        { name: "Less Than <", value: "<" },
        { name: "Greater Than or Equal To >=", value: ">=" },
        { name: "Greater Than >", value: ">" },
      ];
    case "radiogroup":
    case "checkbox":
      return [
        { name: "Equal To ==", value: "==" },
        { name: "Not Equal To !=", value: "!=" },
      ];
    case "dropdown":
    case "tagbox":
      return [
        { name: "Equal To ==", value: "==" },
        { name: "Not Equal To !=", value: "!=" },
        { name: "Greater Than >=", value: ">=" },
        { name: "Less Than <=", value: "<=" },
      ];
    case "date":
      return [
        { name: "was exactly", value: "==" },
        { name: "was not exactly", value: "!=" },
        { name: "was Before", value: "<" },
        { name: "was on or Before", value: "<=" },
        { name: "was After", value: ">" },
        { name: "was on or After", value: ">=" },
      ];
    case "datetime":
      return repeat
        ? [
            { name: "was on or Before", value: "<=" },
            { name: "was Before", value: "<" },
            { name: "was exactly", value: "==" },
            { name: "was After", value: ">" },
            { name: "was on or After", value: ">=" },
          ]
        : [
            { name: "was exactly", value: "==" },
            { name: "was on or Before", value: "<=" },
            { name: "was on or After", value: ">=" },
            { name: "was Before", value: "<" },
            { name: "was After", value: ">" },
          ];
    default:
      return [];
  }
};

const ConditionDropdown: React.FC<ConditionDropdownProps> = ({
  rowIndex,
  values,
  handleBlur,
  setFieldValue,
  otherQueryFilterErrors,
  otherQueryFilterTouched,
  reportSummary,
}) => {
  const type = values.otherQueryFilter[rowIndex].type;
  const inputType = values.otherQueryFilter[rowIndex].inputType;
  const dropdownOptions = getDropdown(
    type === "text" ? inputType : type,
    reportSummary?.reportSetting?.isRepeat,
  );

  return (
    <MaterialUiSelect
      options={dropdownOptions}
      labelKey="name"
      valueKey="value"
      error={otherQueryFilterErrors?.condition}
      initialValue={values?.otherQueryFilter[rowIndex]?.condition}
      handleChange={(value: any) => {
        setFieldValue(`otherQueryFilter[${rowIndex}].condition`, value.value);
      }}
      styles={{ textTransform: "capitalize" }}
      width="100%"
    />
  );
};

export { getDropdown };
export default ConditionDropdown;
